import { styled } from 'baseui';
const MAX_PANEL_WIDTH = 230;
const PREDEFINED_MARGIN = 6;
const PanelContainer = styled<'div', {
  width?: number;
}>('div', ({
  $theme: {
    sizing,
    colors,
    lighting
  },
  width
}) => ({
  position: 'absolute',
  width: `${width ?? MAX_PANEL_WIDTH}px`,
  minHeight: sizing.scale1600,
  margin: `${PREDEFINED_MARGIN}px`,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  borderRadius: sizing.scale100,
  backgroundColor: colors.primaryB,
  boxShadow: lighting.shadow600
}));
export default PanelContainer;